"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class DialogContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogs: props.dialogs ? props.dialogs : []
    };
    this.updateFromStore = this.updateFromStore.bind(this);
  }
  updateFromStore({
    dialogs
  }) {
    this.setState({
      dialogs
    });
  }
  componentDidMount() {
    this.props.dialogContainer.addListener(this.updateFromStore);
  }
  componentWillUnmount() {
    this.props.dialogContainer.removeListener(this.updateFromStore);
  }
  render() {
    const [dialog, ...rest] = this.state.dialogs;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dialog && /*#__PURE__*/_react.default.createElement(Dialog, _extends({}, dialog.params, {
      dialogContainer: this.props.dialogContainer
    })), rest.length ? /*#__PURE__*/_react.default.createElement(DialogContainer, {
      dialogs: rest,
      dialogContainer: this.props.dialogContainer
    }) : null);
  }
}
exports.DialogContainer = DialogContainer;
DialogContainer.propTypes = {
  dialogContainer: _propTypes.default.any,
  dialogs: _propTypes.default.array
};
const Dialog = ({
  component: Component,
  render,
  context,
  dialogContainer
}) => {
  return Component ? /*#__PURE__*/_react.default.createElement(Component, _extends({}, context, {
    dialogContainer: dialogContainer
  })) : render ? render(_objectSpread({}, context)) : null;
};
Dialog.propTypes = {
  component: _propTypes.default.any,
  render: _propTypes.default.func,
  context: _propTypes.default.object,
  dialogContainer: _propTypes.default.object
};